var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconfinder_06-facebook_104498","d":"M27.275,12.572H24.11V10.5a.845.845,0,0,1,.881-.961h2.233V6.108L24.148,6.1a3.9,3.9,0,0,0-4.192,4.192v2.284H17.982V16.1h1.975V26.1H24.11V16.1h2.8Z","transform":"translate(-17.982 -6.096)","fill":"#222"}));
}

FacebookInline.defaultProps = {"width":"9.293","height":"20","viewBox":"0 0 9.293 20"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
